import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import api from '../Axios/axios';
import './CompanyList.scss';

const CompanyList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [companies, setCompanies] = useState([]);
  const [userRole, setUserRole] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = JSON.parse(atob(token.split('.')[1]));
        setUserRole(decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || '');
      } catch (error) {
        setUserRole('');
      }
    }

    const fetchCompanies = async () => {
      try {
        const response = await api.get('/Company');
        setCompanies(response?.data?.data || []);
      } catch (error) {
        console.error('Şirketler yüklenemedi:', error);
        setErrorMessage('Şirketler yüklenemedi. Lütfen tekrar deneyin.');
      }
    };

    fetchCompanies();
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleDeleteClick = (companyId) => {
    setCompanyToDelete(companyId);
    setShowModal(true);
    setErrorMessage('');
  };

  const confirmDelete = async () => {
    if (!companyToDelete || isDeleting) {
      return;
    }

    try {
      setIsDeleting(true);
      setErrorMessage('');

      await api.delete('/Company', {
        params: { id: companyToDelete },
      });

      setCompanies((prev) => prev.filter((company) => company.id !== companyToDelete));
      setShowModal(false);
      setCompanyToDelete(null);
    } catch (error) {
      console.error('Şirket silinemedi:', error);
      const rawResponse =
        typeof error?.response?.data === 'string'
          ? error.response.data
          : JSON.stringify(error?.response?.data || {});
      const apiMessage =
        error?.response?.data?.messages?.join(' ') ||
        error?.response?.data?.message ||
        (error?.response?.status
          ? `Şirket silinemedi. Status: ${error.response.status}. ${rawResponse}`
          : 'Şirket silinemedi. Lütfen tekrar deneyin.');
      setErrorMessage(apiMessage);
    } finally {
      setIsDeleting(false);
    }
  };

  const filteredCompanies = companies.filter((company) =>
    (company.name || '').toLowerCase().includes(searchTerm.toLowerCase())
  );
  const canManageCompanies = userRole === 'Owner' || userRole === 'Employee';

  return (
    <div className="company-list-page">
      <Navbar />
      <div className="company-list-container">
        <div className="company-list-header">
          <h2>Şirketler</h2>
          <div className="search-and-add">
            <input
              type="text"
              placeholder="Şirket adına göre ara..."
              value={searchTerm}
              onChange={handleSearch}
              className="search-bar"
            />
            <Link to="/add-company" className="add-company-btn">
              Şirket Ekle
            </Link>
          </div>
        </div>

        {errorMessage && <p className="error-message">{errorMessage}</p>}

        <table className="company-list-table">
          <thead>
            <tr>
              <th>Şirket Adı</th>
              <th>Email</th>
              <th>Telefon</th>
              {canManageCompanies && <th>İşlemler</th>}
            </tr>
          </thead>
          <tbody>
            {filteredCompanies.length > 0 ? (
              filteredCompanies.map((company) => (
                <tr key={company.id}>
                  <td>{company.name}</td>
                  <td>{company.email}</td>
                  <td>{company.phone || company.phoneNumber1 || 'Veri bulunmuyor'}</td>
                  {canManageCompanies && (
                    <td className="actions">
                      <Link to={`/edit-company/${company.id}`} className="edit-btn">
                        <i className="fas fa-pencil-alt" />
                      </Link>
                      <button className="delete-btn" onClick={() => handleDeleteClick(company.id)}>
                        <i className="fas fa-trash" />
                      </button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={canManageCompanies ? 4 : 3}>Şirket bulunamadı.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Şirketi silmek istediğinize emin misiniz?</h3>
            <div className="modal-actions">
              <button onClick={confirmDelete} className="confirm-delete-btn" disabled={isDeleting}>
                {isDeleting ? 'Siliniyor...' : 'Evet, Sil'}
              </button>
              <button onClick={() => setShowModal(false)} className="cancel-btn" disabled={isDeleting}>
                Vazgeç
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyList;
